import { RootState } from "../types/store.types";

export const selectDrillDownItems = (state: RootState) => state.drillDownPage.pages;
